import { render, staticRenderFns } from "./policesing.vue?vue&type=template&id=142a7840&scoped=true"
import script from "./policesing.vue?vue&type=script&lang=js"
export * from "./policesing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a7840",
  null
  
)

export default component.exports